import {GridRenderCellParams, useGridApiContext} from '@mui/x-data-grid-pro';
import {Typography} from '@mui/material';
import {ReactComponent as RightArrowIcon} from '../../../assests/svg/tree-right-arrow.svg';
import {ReactComponent as DownArrowIcon} from '../../../assests/svg/tree-down-arrow.svg';
import {ReactComponent as FolderIcon} from '../../../assests/svg/folder.svg';
import {ReactComponent as RadioCheckedIcon} from '../../../assests/svg/radio-checked.svg';
import {ReactComponent as RadioUnCheckedIcon} from '../../../assests/svg/radio-unchecked.svg';
import {ReactComponent as SearchIcon} from '../../../assests/svg/search-icon-right.svg';
import {ReactElement} from 'react';

export type GroupGridRenderCellParams = GridRenderCellParams & {
  rowNode: {
    children: number[];
    childrenExpanded: boolean;
    groupingKey: string;
    type: 'group' | 'leaf';
    depth?: number;
  };
};

type CustomGroupCellPropType = {
  params: GroupGridRenderCellParams;
  isSelected?: boolean;
  renderGroupContent?: (
    expanded: boolean,
    params: GroupGridRenderCellParams
  ) => ReactElement; // Use this rendeProp pattern function to show custom ui for group cotent in tree instead of default
  renderLeafContent?: (
    params: GroupGridRenderCellParams,
    isSelected?: boolean
  ) => ReactElement; // Use this renderProp pattern function to show custom ui for leaf of tree node
};

// Custom cell renderer
const CustomTreeGroupCell: React.FC<CustomGroupCellPropType> = (props) => {
  const apiRef = useGridApiContext();
  const {params, isSelected} = props;
  const {id, rowNode, value} = params;
  const {childrenExpanded, depth = 0, children, type} = rowNode;

  const handleExpandClick = () => {
    apiRef.current.setRowChildrenExpansion(id, !childrenExpanded);
  };

  const renderGroupContent = () => {
    if (props.renderGroupContent)
      return props.renderGroupContent(
        children?.length > 0 && childrenExpanded,
        params
      );

    return (
      <>
        {/* Expand/Collapse Arrow */}
        {children?.length > 0 && childrenExpanded ? (
          <DownArrowIcon />
        ) : (
          <RightArrowIcon />
        )}

        {/* Folder Icon */}
        <FolderIcon />

        {/* Caption */}
        <Typography className="typo-text body3_size title-label">
          {value}
        </Typography>
      </>
    );
  };

  const renderLeafContent = () => {
    if (props.renderLeafContent)
      return props.renderLeafContent(params, isSelected);

    return (
      <>
        {isSelected ? <RadioCheckedIcon /> : <RadioUnCheckedIcon />}
        <SearchIcon />
        <Typography className="typo-text body3_size title-label">
          {value}
        </Typography>
      </>
    );
  };

  return (
    <div
      className="custom-group-cell-container"
      style={{paddingLeft: `${depth * 28}px`}}
      onClick={type === 'group' ? handleExpandClick : undefined}
    >
      {type === 'group' && renderGroupContent()}
      {type === 'leaf' && renderLeafContent()}
    </div>
  );
};

export default CustomTreeGroupCell;
